import {ReactNode} from "react";
import styled, {css} from "styled-components";

interface ListProps {
	children: ReactNode;
	color?: string;
}
// 필요한 color 있으면 추가해서 사용
const Item = styled.li<{color?: string}>`
	position: relative;
	padding-left: 12px;
	font-size: var(--basic-size);
	color: var(--default-color);
	word-break: keep-all;

	&::before {
		position: absolute;
		top: 8px;
		left: 0;
		display: block;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background: var(--bl-color);
		content: "";
	}

	a {
		text-decoration: underline;
	}

	${props => {
		if (props.color === "blue") {
			return css`
				color: var(--blue-color);
			`;
		}
	}}
	${props => {
		if (props.color === "red") {
			return css`
				color: var(--red-color);
			`;
		}
	}}

    strong {
		color: var(--emp-color);
	}
`;

const BulletListItem = ({children, color}: ListProps) => <Item color={color}>{children}</Item>;

export default BulletListItem;
